/**
 * THE HELP RECORDS' IDS — plan-019 DOM (design §31.3.2; ADRs 0067, 0068, proposed).
 *
 * UUID v7, minted in the application like every other id (design 4.1 S3). The help request and its replies, notes,
 * takeovers, operator lines and actions are platform tables (migration 0153); the help conversation is an ordinary
 * `conversation` and keeps `ConversationId`.
 */
import { idCodec } from "../id/brand.js";
export const helpRequestIdCodec = idCodec("HelpRequestId");
export const helpRequestReplyIdCodec = idCodec("HelpRequestReplyId");
export const helpRequestNoteIdCodec = idCodec("HelpRequestNoteId");
export const helpTakeoverIdCodec = idCodec("HelpTakeoverId");
export const helpOperatorLineIdCodec = idCodec("HelpOperatorLineId");
export const helpActionIdCodec = idCodec("HelpActionId");
//# sourceMappingURL=id.js.map